export const GET_PET_TRANSACTIONS_REQUEST = 'GET_PET_TRANSACTIONS_REQUEST';
export const GET_PET_TRANSACTIONS_SUCCESS = 'GET_PET_TRANSACTIONS_SUCCESS';
export const GET_PET_TRANSACTIONS_FAILED = 'GET_PET_TRANSACTIONS_FAILED';

export const GET_TRANSACTION_REQUEST = 'GET_TRANSACTION_REQUEST';
export const GET_TRANSACTION_SUCCESS = 'GET_TRANSACTION_SUCCESS';
export const GET_TRANSACTION_FAILED = 'GET_TRANSACTION_FAILED';

export const UPDATE_TRANSACTION_REQUEST = 'UPDATE_TRANSACTION_REQUEST';
export const UPDATE_TRANSACTION_SUCCESS = 'UPDATE_TRANSACTION_SUCCESS';
export const UPDATE_TRANSACTION_FAILED = 'UPDATE_TRANSACTION_FAILED';

export const APPLY_CODE_REQUEST = 'APPLY_CODE_REQUEST';
export const APPLY_CODE_SUCCESS = 'APPLY_CODE_SUCCESS';
export const APPLY_CODE_FAILED = 'APPLY_CODE_FAILED';

export const RESCAN_FOR_CODES_REQUEST = 'RESCAN_FOR_CODES_REQUEST';
export const RESCAN_FOR_CODES_SUCCESS = 'RESCAN_FOR_CODES_SUCCESS';
export const RESCAN_FOR_CODES_FAILED = 'RESCAN_FOR_CODES_FAILED';

export const RETRY_CODE_REQUEST = 'RETRY_CODE_REQUEST';
export const RETRY_CODE_SUCCESS = 'RETRY_CODE_SUCCESS';
export const RETRY_CODE_FAILED = 'RETRY_CODE_FAILED';

export const GET_DENIAL_REASON_REQUEST = 'GET_DENIAL_REASON_REQUEST';
export const GET_DENIAL_REASON_SUCCESS = 'GET_DENIAL_REASON_SUCCESS';
export const GET_DENIAL_REASON_FAILED = 'GET_DENIAL_REASON_FAILED';

export const DELETE_RECEIPT_REQUEST = 'DELETE_RECEIPT_REQUEST';
export const DELETE_RECEIPT_SUCCESS = 'DELETE_RECEIPT_SUCCESS';
export const DELETE_RECEIPT_FAILED = 'DELETE_RECEIPT_FAILED';

export const CLEAR_TRANSACTION = 'CLEAR_TRANSACTION';
